export default __webpack_public_path__ + "static/media/AAutoSignature-1GD9j.0951a8cf.ttf";